import { FormControlLabel, Stack, Switch, TextField } from "@mui/material";
import type { EntityFieldType } from "../../../../../api/types/objectTypes";
import FieldTypeSelect from "../../../data-model/object-fields/field-editor/FieldTypeSelect";
import type {
  WorkflowTemplateActivityFieldFormState,
  WorkflowTemplateActivityFieldFormTouchedField,
  WorkflowTemplateActivityFieldFormTouchedFields,
  WorkflowTemplateActivityFieldFormValidationResults,
} from "./workflowTemplateActivityFieldFormState";

interface Props {
  formState: WorkflowTemplateActivityFieldFormState;
  validationResults: WorkflowTemplateActivityFieldFormValidationResults;
  touchedFields?: WorkflowTemplateActivityFieldFormTouchedFields;
  disableDisplayName?: boolean;
  disableType?: boolean;
  allowedFieldTypes?: readonly EntityFieldType[];
  onChange: (formState: WorkflowTemplateActivityFieldFormState) => void;
  onFieldTouched?: (field: WorkflowTemplateActivityFieldFormTouchedField) => void;
}

const WorkflowTemplateActivityFieldForm = ({
  formState,
  validationResults,
  touchedFields,
  disableDisplayName,
  disableType,
  allowedFieldTypes,
  onChange,
  onFieldTouched,
}: Props) => {
  const showDisplayNameError = touchedFields === undefined || touchedFields.displayName === true;
  const showDescriptionError = touchedFields === undefined || touchedFields.description === true;

  return (
    <Stack spacing={2.5}>
      <TextField
        fullWidth
        label="Name"
        value={formState.displayName}
        onChange={(e) => {
          onFieldTouched?.("displayName");
          onChange({ ...formState, displayName: e.target.value });
        }}
        error={showDisplayNameError && !validationResults.displayName.isValid}
        helperText={showDisplayNameError ? validationResults.displayName.error : ""}
        disabled={disableDisplayName}
      />

      <FieldTypeSelect
        fieldType={formState.type}
        onChange={(type) => onChange({ ...formState, type })}
        disabled={disableType}
        allowedFieldTypes={allowedFieldTypes}
      />

      <TextField
        fullWidth
        multiline
        minRows={5}
        maxRows={15}
        label="Description & Agent Instructions"
        value={formState.description}
        onChange={(e) => {
          onFieldTouched?.("description");
          onChange({ ...formState, description: e.target.value });
        }}
        error={showDescriptionError && !validationResults.description.isValid}
        helperText={showDescriptionError ? validationResults.description.error : ""}
      />

      <FormControlLabel
        control={
          <Switch
            checked={formState.isRequired}
            onChange={(e) => onChange({ ...formState, isRequired: e.target.checked })}
          />
        }
        label="Required Field"
      />
    </Stack>
  );
};

export default WorkflowTemplateActivityFieldForm;
